import React from "react";
import logo from "../../assets/Vcars.png";
import logo1 from "../../assets/Vceramic.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div
        className="flex items-center justify-between md:justify-evenly font-bold shrink-0 px-4"
        style={{
          background: "#2E2E2E",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          fontFamily: "Barlow Condensed",
        }}
      >
        <Link to="/" className="flex justify-center">
          <img src={logo} alt="logo" className="w-1/2" />
        </Link>
        <Link
          to="/"
          state={{ scrollTo: "services" }}
          className="flex justify-center"
        >
          <img src={logo1} alt="logo" className="w-1/2" />
        </Link>
      </div>
    </>
  );
};

export default Header;
